import { colors, fontWeights } from 'ui/theme';
import { ItemState } from '../../../constants';
import {
  deleteStyles,
  deleteStylesActive,
  fontConfig,
  shapeNames,
  DEFAULT_NOTE_WIDTH,
  DEFAULT_NOTE_HEIGHT,
} from '../../constants';
import {
  BODY_MARGIN_BOTTOM,
  BODY_MARGIN_TOP,
  CORNER_WIDTH,
  DEFAULT_EMPTY_TEXT,
  DEFAULT_TITLE_ROWS,
  EXPANDED_HEIGHT,
  EXPANDED_WIDTH,
  PADDING_HORIZONTAL,
  PADDING_VERTICAL,
} from './note.constants';
import { linkIcon, linkHoverIcon } from './icons';

const wrapperBaseStyle = {
  fill: colors.mustard10,
  lineCap: 'round',
  lineJoin: 'round',
  lineWidth: 1,
  stroke: colors.mustard50,
  strokeOpacity: 1,
};

const emptyBodyStyle = {
  opacity: 0.3,
  fill: colors.mustard100,
  text: DEFAULT_EMPTY_TEXT,
};

const baseBodyStyle = {
  opacity: 1,
  fill: colors.grey90,
};

export const noteStyles = {
  width: DEFAULT_NOTE_WIDTH,
  height: DEFAULT_NOTE_HEIGHT,
  [shapeNames.wrapper]: { ...wrapperBaseStyle, padding: [PADDING_VERTICAL, PADDING_HORIZONTAL] },
  [shapeNames.corner]: { ...wrapperBaseStyle, width: CORNER_WIDTH },
  [shapeNames.shadow]: {
    fill: 'white',
    opacity: 0.4,
    shadowBlur: 6,
    shadowColor: '#000000',
    shadowOffsetX: 0,
    shadowOffsetY: 2,
    stroke: 'transparent',
  },
  [shapeNames.title]: {
    ...fontConfig.default,
    ...fontConfig.fs11,
    fill: colors.mustard100,
    fontWeight: fontWeights.bold,
    letterSpacing: 2,
    rows: DEFAULT_TITLE_ROWS,
    textBaseline: 'middle',
  },
  [shapeNames.body]: {
    ...fontConfig.default,
    ...fontConfig.fs12,
    fill: colors.grey90,
    fontWeight: fontWeights.regular,
    lineHeight: 16,
    margin: [BODY_MARGIN_TOP, 0, BODY_MARGIN_BOTTOM, 0],
    textBaseline: 'top',
    placeholder: DEFAULT_EMPTY_TEXT,
    placeholderStyle: emptyBodyStyle,
    baseStyle: baseBodyStyle,
    inlineEdit: baseBodyStyle,
  },
  [shapeNames.emptyBody]: {
    opacity: 0.3,
    fill: colors.mustard100,
    text: DEFAULT_EMPTY_TEXT,
  },
  [shapeNames.linkIcon]: {
    img: linkIcon,
    hoverImg: linkHoverIcon,
    baseImg: linkIcon,
    width: 16,
    height: 16,
    cursor: 'pointer',
    margin: [0, 8, 0, 0],
  },
  ...deleteStyles,
};

export const noteStateStyles = {
  [ItemState.Selected]: {
    [shapeNames.wrapper]: {
      stroke: colors.mustard100,
    },
    [shapeNames.corner]: {
      stroke: colors.mustard100,
    },
  },
  // hover
  [ItemState.Active]: {
    ...deleteStylesActive,
    width: EXPANDED_WIDTH,
    height: EXPANDED_HEIGHT,
    // NOTE: If an empty object isn't here, then the corner resets on mouseleave
    // when selected
    [shapeNames.corner]: {},
  },
  [ItemState.InlineEdit]: {
    width: EXPANDED_WIDTH,
    height: EXPANDED_HEIGHT,
    [shapeNames.deleteCircle]: {
      opacity: 0,
    },
    [shapeNames.deleteIcon]: {
      opacity: 0,
    },
  },
};
